const ticket = {
  dictionary: [],
  fullname: '',
  email: '',
  phonenumber: '',
  q_id: null,
};

export default ticket;
